export default "__VITE_ASSET__Le_fKy$w__"